import { DatePicker as CarbonDatePicker, DatePickerInput } from "@carbon/react";

export const View = ({ name, startDate, endDate }) => {
  return (
    <CarbonDatePicker
      datePickerType="range"
      size="sm"
      className="date-range--picker"
    >
      <div className="date-range--start">
        <div className="icon--container"></div>
        <DatePickerInput
          id={name}
          light
          placeholder="start"
          value={`${startDate} - ${endDate}`}
          onOpen={function (e) {
            // clear date range
          }}
        />
      </div>

      <div className="date-range--end">
        <DatePickerInput placeholder="end" />
      </div>
    </CarbonDatePicker>
  );
};
